var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":null,"visible":_vm.showAnyImage,"dialogClass":"demo__AnyImageModal","footer":null},on:{"cancel":_vm.closeModal}},[_c('img',{attrs:{"src":_vm.anyImageSrc || '/404Serie.png'},on:{"error":(e) => {
        e.target.src = '/404Serie.png';
      }}}),_c('i',{staticClass:"fa-light fa-xmark-large demo__color--white",attrs:{"aria-hidden":"true"},on:{"click":_vm.closeModal}})])
}
var staticRenderFns = []

export { render, staticRenderFns }